export enum EContinent {
    EUROPE = 'europe',
    AFRICA = 'africa',
    ASIA = 'asia',
    NORTH_AMERICA = 'north_america',
    SOUTH_AMERICA = 'south_america',
    OCEANIA = 'oceania',
    ANTARCTICA = 'antarctica',
}

export const continentAsString = (continent: EContinent | string): string => {
    switch (continent) {
        case EContinent.EUROPE:
            return "Europe";
        case EContinent.AFRICA:
            return "Afrique";
        case EContinent.ASIA:
            return "Asie";
        case EContinent.NORTH_AMERICA:
            return "Amérique du Nord";
        case EContinent.SOUTH_AMERICA:
            return "Amérique du Sud";
        case EContinent.OCEANIA:
            return "Océanie";
        case EContinent.ANTARCTICA:
            return "Antarctique";
        default:
            return continent.toString();
    }
};